import * as React from "react";
import { Avatar as AntdAvatar, Tooltip } from "antd";
// Hooks
import { getInitials } from "../../utils/functions/getInitials";
import { getHslFromString } from "../../utils/functions/getHslFromString";

type AvatarProps = {
  name: string;
  size?: any;
  noMargin?: boolean;
  tooltipContent?: JSX.Element;
};

export default function Avatar({
  name: propsName,
  size: propsSize = "default",
  noMargin: propsNoMargin = false,
  tooltipContent: propsTooltipContent = undefined,
}: AvatarProps) {
  return (
    <Tooltip title={propsTooltipContent ? propsTooltipContent : propsName}>
      <AntdAvatar
        size={propsSize}
        style={{
          marginRight: propsNoMargin ? 0 : 12,
          color: getHslFromString(propsName, 30, 30),
          backgroundColor: getHslFromString(propsName, 30, 80),
        }}
      >
        {getInitials(propsName)}
      </AntdAvatar>
    </Tooltip>
  );
}
